export enum HTTP_HEADERS {
  MY_TRIP = 'MyTrip',
  BEARER = 'Bearer',
  CONTENT_TYPE = 'application/json; charset=UTF-8',
  TODAYS_TRIP = 'TodaysTrip'
}

export enum MOST_UPCOMING_TRIP {
  SKY_MILE_NUMBER = '${skymilesNbr}',
  NO_OF_TRIPS = '${nmbrOfTrips}',
  TRANSACTION_ID = '${transactionId}'
}

export enum MyTripEndpointKeys {
  APP_TRIPS_UPCOMING_TRIP_URL = 'APP_TRIPS_UPCOMING_TRIP_URL',
  GET_TODAYS_TRIP_AWS_URL = 'GET_TODAYS_TRIP_AWS_URL'
}

export const BEARER = 'Bearer';
export const HEADER = 'HEADER';
export const DEFAULT_TIMEOUT = 30000;
export const SHARED_UPCOMING_TRIP = 'SHARED_UPCOMING_TRIP';
